import { render, staticRenderFns } from "./testers.vue?vue&type=template&id=4dd42351&"
import script from "./testers.vue?vue&type=script&lang=js&"
export * from "./testers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports